import React, { useEffect, useState } from 'react';
import axiosInstance from '../../../utils/axiosInstance';
import { Link } from 'react-router-dom';
import DeleteProducts from './DeleteProducts';

const GetAllProduct = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  useEffect(() => {
    setLoading(true);

    axiosInstance
      .get(`/api/products/getall?page=${currentPage}`)
      .then((response) => {
        setProducts(response.data);
        setHasMore(response.data.length > 0);
      })
      .catch((error) => {
        console.error('Error fetching products:', error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [currentPage]);

  const handleDeleteSuccess = async () => {
    try {
      const updatedProducts = await setProducts();
      setProducts(updatedProducts);
    } catch (error) {
      console.error('Error deleting product:', error);
    }
  };

  const handleShowMore = () => {
    setCurrentPage((prevPage) => prevPage + 1);
  };

  const handleShowLess = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <h1 className=''> All Products</h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
      {products.map((product) => (
        <div key={product._id} className="bg-white p-4 shadow-md rounded-md hover:shadow-xl transition">
          <Link to={`/admin/update/${product._id}`}>
            <img
              src={`${axiosInstance.defaults.baseURL}/${product.image}`}
              alt={product.name}
              className="w-full h-40 object-cover mb-4 rounded"
            />
            <div>
              <p className="text-lg font-bold mb-2">{product.name}</p>
              <p className="text-base mb-2">Rs:{product.price}</p>
              <p className="text-base mb-2">Rs:{product.addedAt}</p>
              {/* ... (rest of your product rendering logic) */}
            </div>
          </Link>

          <div className="flex justify-between mt-4">
            <Link to={`/admin/update/${product._id}`} className="text-blue-500 hover:underline">
              Update
            </Link>

            {/* Add the DeleteProducts component with the product ID */}
            <DeleteProducts id={product._id} onDeleteSuccess={handleDeleteSuccess} />
          </div>
        </div>
      ))}
      </div>

      <div className="mt-4 flex justify-between">
        <button
          onClick={handleShowLess}
          className={`bg-blue-500 text-white px-4 py-2 rounded ${currentPage === 1 && 'opacity-50 cursor-not-allowed'}`}
          disabled={currentPage === 1}
        >
          Previous
        </button>

        <button
          onClick={handleShowMore}
          className="bg-blue-500 text-white px-4 py-2 rounded"
        >
          Next
        </button>
      </div>
    </>
  );
};

export default GetAllProduct;
